import ApiService from "@/core/services/api.service";
// action types
export const GET_PDF = "getPdf";
export const GET_PROJECTS = "getProjects";
export const GET_PROJECT = "getProject";
export const GET_PROJECTOS_WP = "getProjectosWp";
export const GET_PROJECT_WP = "getProjectWp";
export const GET_MODELO_WP = "getModeloWp";
export const GET_MODELOS_WP = "getModelosWp";
export const CREATE_COTIZACION = "createCotizacion";
// mutation types
export const SET_PROJECTS = "setProjects";
export const SET_PROJECT = "setProject";
export const SET_PROJECT_WP = "setProjectWp";
export const SET_PROJECTOS_WP = "setProjectosWp";
export const SET_MODELO_WP = "setModeloWp";
export const SET_MODELOS_WP = "setModelosWp";

export const SET_ERROR = "setError";

const state = {
  errors: [],
  project:{etapaNav:{}},
  project_wp:{},
  projectos_wp:{},
  modelo_wp:{},
  projects:[],
  modelos_wp:[]
};

const actions = {
  [GET_PDF](context, archivo) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.query({action: `/gateway/Proyecto/v1/mibricsa/catalogo/${archivo}`}, {responseType: 'blob'})
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          console.log('err' + response);
          context.commit(SET_ERROR, '');//response.data.errors);
        });
    });
  },

  [GET_PROJECTS](context, params) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.query({action:`/gateway/Proyecto/v1/mibricsa/proyectos/`}, params)
        .then(({ data }) => {
          context.commit(SET_PROJECTS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [GET_PROJECT](context, idNegocio) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/gateway/Proyecto/v1/mibricsa/proyecto/${idNegocio}`}, '')
        .then(({ data }) => {
          context.commit(SET_PROJECT, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  }
  ,
  [GET_PROJECT_WP](context, sci) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/gateway/Proyecto/v1/mibricsa/proyectowp/${sci}`}, '')
        .then(({ data }) => {
          context.commit(SET_PROJECT_WP, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [GET_PROJECTOS_WP](context, params) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.query({action:`/gateway/Proyecto/v1/mibricsa/proyectoswp/`}, params)
        .then(({ data }) => {
          context.commit(SET_PROJECTOS_WP, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [GET_MODELO_WP](context, sci) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/gateway/Modelo/v1/mibricsa/modelowp/${sci}`}, '')
        .then(({ data }) => {
          context.commit(SET_MODELO_WP, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [GET_MODELOS_WP](context, url) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.get({action:`/gateway/Modelo/v1/mibricsa/modeloswp/${url}`}, '')
        .then(({ data }) => {
          context.commit(SET_MODELOS_WP, data);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, response.data.errors);
        });
    });
  },
  [CREATE_COTIZACION](context, cotizacion) {
    return new Promise(resolve => {
      ApiService.setHeader();
      ApiService.post({action:`/gateway/proyecto/v1/mibricsa/cotizar`}, cotizacion)
        .then(({ data }) => {
          context.commit(SET_ERROR, []);
          resolve(data);
        })
        .catch(({ response }) => {
          console.log(response);
          context.commit(SET_ERROR, response.data.errors);
          resolve(response);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_PROJECTS](state, data) {
    state.errors = [];
    console.log(data);
    state.projects = data;
  },
  [SET_PROJECT](state, data) {
    state.errors = [];
    console.log(data);
    state.project = data;
  },
  [SET_PROJECT_WP](state, data) {
    state.errors = [];
    console.log(data);
    state.project_wp = data;
  },
  [SET_PROJECTOS_WP](state, data) {
    state.errors = [];
    console.log(data);
    state.projectos_wp = data;
  },
  [SET_MODELO_WP](state, data) {
    state.errors = [];
    console.log(data);
    state.modelo_wp = data;
  },
  [SET_MODELOS_WP](state, data) {
    state.errors = [];
    console.log(data);
    state.modelos_wp = data;
  },
};

export default {
  state,
  actions,
  mutations
};
